import React from 'react';
import Helmet from 'react-helmet';

import Mapillary from './Mapillary';

import styles from './ZoneDesc.module.scss';

const ZoneSectionMapillary = ({ zones = [] }) => (
  <div className={styles.mapillary}>
    <Helmet>
      <script src="https://unpkg.com/mapillary-js@4.0.0/dist/mapillary.js" />
      <link href="https://unpkg.com/mapillary-js@4.0.0/dist/mapillary.css" rel="stylesheet" />
    </Helmet>

    {zones.map(zone => (
      <Mapillary
        key={zone.id_eae}
        imageKey={zone.id_mapillary}
      />
    ))}
  </div>
);

export default ZoneSectionMapillary;
